import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { AuthService } from '../services/auth.service';
import { UsuarioService } from '../services/usuario.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { EquipeService } from '../services/equipe.service';
import { MochilaService } from '../services/mochila.service';


import { CheckMochilaService } from '../services/check-mochila.service';

@Component({
  selector: 'app-checklist-mochila-edit',
  templateUrl: './checklist-mochila-edit.component.html',
  styleUrls: ['./checklist-mochila-edit.component.css'],
  animations: [loadingFade]
})
export class ChecklistMochilaEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

  public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];
  public mochilas = [];
  public equipes: any;
  public cliente: any;
  public check_mochila_inicio = moment().format('YYYY-MM-DD HH:mm:ss');

  public check_mochila_id = null;
  public profissional = null;
  public usuario_perfil;
  public usuario_logado_id;
  public cliente_user_id;
  public unidade_user_id;
  public profissional_usar_id;

  public equipe = [];
  public item_equipe_array = [];
  public flag = false;

    //filtros
    public cliente_id___cliente = null;
    public unidade_id___unidade = null;
    public veiculo_id___veiculo = null;
    public check_mochila_turno___periodo = null;
    public check_mochila_data___data_i = null;
    public check_mochila_data___data_f=  null;
    public profissional_id___profissional = null;
  

  // datepickers
  private data_checklist_dp;


  constructor(private authSvc: AuthService,
    private usuarioSvc: UsuarioService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService,
    private equipeSvc: EquipeService,
    private checkMochilaSvc: CheckMochilaService,
    private mochilaSvc: MochilaService,
    private veiculoSvc: VeiculoService,
  ) { }

  ngOnInit() {

    this.usuario_logado_id = this.authSvc.getUsuarioId();
    this.usuario_perfil = this.authSvc.getPerfil();
   
    this.pegaAgencias();    
    //this.pegaMochilas();
    this.criaForm();
    //this.verificaCliente();
    //this.pegaProfissionais();

    
    this.loading = true;   

    this.route.params.subscribe(params => {
      if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_mochila_turno___periodo": { 
                this.check_mochila_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_mochila_data___data_i": { 
                this.check_mochila_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_mochila_data___data_f": { 
                this.check_mochila_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }
        }          


        this.check_mochila_id = params.id;
        this.checkMochilaSvc.getCheckMochila(params.id).then((data: any) => {
          this.cliente = data.cliente_id;

          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculos(data.unidade_id);
          this.pegaVeiculoUnidadeProfissional(data);

          this.preencheForm({
            check_mochila_id: data.check_mochila_id,
            usuario_id: data.usuario_id,
            check_mochila_data: moment(data.check_mochila_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_mochila_turno: data.check_mochila_turno,
            cliente_id: data.cliente_id,
            unidade_id: data.unidade_id,
            profissional_id: data.profissional_id,
            veiculo_id: data.veiculo_id,
            mochila_id: data.mochila_id,
            produtos: []
          });          

          

          
          this.flag = true;
          const produtos = this.formChecklist.get('produtos') as FormArray;
          for (let prod of data.produtos) {
            produtos.push(this.createItemMochila(prod.produto_nome, prod.produto_id, prod.check_mochila_produto_quantidade, prod.check_mochila_produto_presenca, prod.check_mochila_produto_obs));
          }


          //this.verificaCliente();
          this.loading = false;
        });
      }
      else {
        
        if(this.usuario_perfil != 2){
          this.loading = true;
          this.getClienteUnidadeUsuarioLogado(this.usuario_logado_id);
        }
        this.loading = false;

      }
    });
  }

  criaForm() {

    this.formChecklist = this.fb.group({
      check_mochila_id: null,
      usuario_id: this.authSvc.getUsuarioId(),
      check_mochila_data: [moment().format('DD/MM/YYYY'), Validators.required],
      check_mochila_turno: [this.pegaPeriodo(), Validators.required],
      cliente_id: [null, Validators.required],
      unidade_id: [null, Validators.required],
      profissional_id: [null, Validators.required],
      veiculo_id: [null, Validators.required],
      mochila_id: [null, Validators.required],
      produtos: this.fb.array([])
    });

    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#check_mochila_data', {
      customMonths: moment.months(),
      customDays: moment.weekdaysShort(),
      overlayPlaceholder: 'Preencha o ano',
      overlayButton: 'Enviar',
      formatter: (element, date) => {
        let formatted = moment(date).format('DD/MM/YYYY');
        this.formChecklist.controls['check_mochila_data'].setValue(formatted);
      }
    });

    /*if (this.authSvc.getPerfil() != 2) {


      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        //this.formChecklist.get('profissional_id').disable();
      });
    }*/

  }

  preencheForm(dados) {
    this.formChecklist.setValue(dados);
  }

  pegaPeriodo() {
    let hora = parseInt(moment().format('HH'));
    if (hora > 7 && hora < 19) {
      return 'D';
    }
    else {
      return 'N';
    }
  }


  pegaAgencias() {
    
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });


  }

  getClienteUnidadeUsuarioLogado(usuario_id) {

    //Verifica se existe Profissional vinculado a tb_usuario para buscar dados referente a o profissional
    this.usuarioSvc.ClienteUnidadeUser(usuario_id).then((data: any) => {
      
      this.cliente_user_id = data[0].cliente_id;
      this.unidade_user_id = data[0].unidade_id;
      this.profissional_usar_id = data[0].profissional_id;

      if(data[0].cliente_id !== null){

          this.pegaUnidadesByAgencia(this.cliente_user_id);
          this.pegaProfissionaisClienteUnidade(this.cliente_user_id,this.unidade_user_id);
          this.pegaMochilasPorUnidade(this.unidade_user_id);

          //veiculo
          this.veiculos = [];
          this.veiculoSvc.getByVeiculoUnidadeEspecialidade(this.unidade_user_id,"todos").then((data: any[]) => {

              let dados = [];
              for(let veiculo of data){
                dados.push({
                veiculo_id: veiculo.veiculo_id,
                placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
                unidade_id: this.unidade_user_id,
                cliente_id: this.cliente_user_id
                });
              }
              this.veiculos = dados;

          }).catch((err) => {
            console.log(err);
          });

          
          this.cliente = this.cliente_user_id;
          this.preencheForm({
            check_mochila_id: null,
            usuario_id: this.usuario_logado_id,
            check_mochila_data: moment().format('DD/MM/YYYY'),
            check_mochila_turno: null,
            cliente_id: this.cliente_user_id,
            unidade_id: this.unidade_user_id,
            profissional_id: this.profissional_usar_id,
            veiculo_id: null,
            mochila_id: null,
            produtos: []
          }); 


          //this.formChecklist.get('cliente_id').disable();
          //this.formChecklist.get('unidade_id').disable();
          //this.formChecklist.get('profissional_id').disable();

    }

    }).catch((err) => {
      console.log(err);
    });
  }


  pegaUnidadesByAgencia(agencia_id) {
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaVeiculos(unidade) {
    this.veiculoSvc.getVeiculosByUnidade(unidade).then((data: any[]) => {
      this.veiculos = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaMochilas() {
    this.mochilaSvc.getMochilas().then((data: any[]) => {
      this.mochilas = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaMochilasPorUnidade(unidade_id) {
    this.mochilaSvc.getMochilaPorUnidade(unidade_id).then((data: any[]) => {
        this.mochilas = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeAgencia(e) {
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    //this.verificaCliente();
    this.cliente = e.cliente_id;
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e) {
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.pegaVeiculos(e.unidade_id);
  }

  pegaProfissionais() {
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
      this.profissionais = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  invalid(nome) {
    let input = this.formChecklist.get(nome);
    return input.touched && input.invalid;
  }

  verificaCliente() {
    /*if (this.formChecklist.get('cliente_id').value)
      this.formChecklist.get('unidade_id').enable();
    else
      this.formChecklist.get('unidade_id').disable();*/
  }


  enviaChecklist() {

    this.formChecklist.get('cliente_id').enable();
    this.formChecklist.get('unidade_id').enable();
    this.formChecklist.get('profissional_id').enable();

    if (this.formChecklist.valid) {
      this.submitting = true;
      //this.formChecklist.get('profissional_id').enable();
      let toSend = this.formChecklist.value;

      //Valida Insumos 
      const produtos = this.formChecklist.get('produtos') as FormArray;
      let contaItensSemObs = 0;
      for(let prod of toSend.produtos){

        if(prod.check_mochila_produto_presenca == "N" && prod.check_mochila_produto_obs.length == 0){
          contaItensSemObs = contaItensSemObs + 1;
        }

      }


      if(contaItensSemObs > 0){
          Swal.fire({
              type: 'error',
              title: 'Checklist incompleto!',
              text: 'Verifique os itens do Insumos!'
            });
            for (let field in this.formChecklist.controls) {
              let campo = this.formChecklist.get(field);
              campo.markAsTouched();
            }
        return "";
      }

      console.log("[toSend]",  toSend);
      if (this.check_mochila_id === null) { // criar
        toSend.check_mochila_inicio = this.check_mochila_inicio;
        toSend.check_mochila_registro = moment().format('YYYY-MM-DD HH:mm:ss');
        this.checkMochilaSvc.criaCheckMochila(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: () => {
              this.router.navigate(['home/checkmochila']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
        });
      }
      else { // editar
        this.checkMochilaSvc.editaCheckMochila(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: () => {
              this.router.navigate(['home/checkmochila']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
        });
      }
    }
    else {
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for (let field in this.formChecklist.controls) {
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
  }


  createItemMochila(nome = null, id = null, quantidade = null, presenca = null, obs = null) {
    return this.fb.group({
      produto_id: id,
      produto_nome: nome,
      //quantidade: [{ value: quantidade, disabled: false }],
      check_mochila_produto_quantidade: quantidade,
      check_mochila_produto_presenca: [presenca, [Validators.required]],
      check_mochila_produto_obs: obs,
    });
  }

  onChangeMochila(e) {

    if (e != null) {
      const prods = this.formChecklist.get('produtos') as FormArray;
      for (let i = prods.controls.length; i >= 0; i--) {
        prods.removeAt(i);
      }

      if (e.produtos.length > 0) {
        this.flag = true;
        for (let produto of e.produtos) {
          prods.push(this.createItemMochila(produto.produto_nome, produto.produto_id, produto.mochila_produto_quantidade));
        }
      }
      else {
        this.flag = false;
      }
    }
    else {
      this.flag = false;
    }
  }

  onChangeConforme(index) {
    let items = this.formChecklist.get('produtos') as FormArray;
    let inputRadio = items.at(index).get('check_mochila_produto_presenca');
    let inputObs = items.at(index).get('check_mochila_produto_obs');

    if (inputRadio.value === 'N') {
      inputObs.setValidators(Validators.required);
      inputObs.updateValueAndValidity();
      inputObs.markAsTouched();
      inputObs.invalid;
    } else {
      inputObs.clearValidators();
      inputObs.updateValueAndValidity();
    }
  }


  onChangeVeiculoUnidade(e){
    this.pegaVeiculoUnidadeProfissional(e);
	}

  pegaVeiculoUnidadeProfissional(e){
		  
      this.formChecklist.controls.veiculo_id.setValue(null);
      this.formChecklist.controls.profissional_id.setValue(null);
      this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"todos").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}

			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e.cliente_id,e.unidade_id);
      this.pegaMochilasPorUnidade(e.unidade_id);
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });

  }

  pegaProfissionaisClienteUnidade(cliente_id,unidade_id){

		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(cliente_id,unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	}	

    onClickVoltar(){

      let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
      params += "&unidade_id___unidade=" + this.unidade_id___unidade;
      params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
      params += "&check_mochila_turno___periodo=" + this.check_mochila_turno___periodo;
      params += "&check_mochila_data___data_i=" + this.check_mochila_data___data_i;
      params += "&check_mochila_data___data_f=" + this.check_mochila_data___data_f;
      params += "&profissional_id___profissional=" + this.profissional_id___profissional;
  
      this.router.navigate(['/home/checkmochilafiltro/' + params]);
  
    }

}
